import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import { auth } from './lib/auth'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Data jsou ziva a stejne se obnovuji intervalem; dalsi kolo dotazu pri
      // kazdem prepnuti okna by uz nic nepridalo.
      refetchOnWindowFocus: false,
      staleTime: 2_000,
      retry: 1,
    },
  },
})

const router = createRouter({
  routeTree,
  context: { auth, queryClient },
  defaultPreload: 'intent',
})

// Registrace typu routeru — diky ni jsou <Link to="..."> a Route.useParams()
// typove kontrolovane proti skutecnemu stromu cest.
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Uzivatele k tokenu dotahneme jeste pred prvnim vykreslenim. Bez toho by
// hlavicka po tvrdem nacteni stranky na okamzik ukazala prazdny e-mail.
auth.restore().finally(() => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  )
})
